var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareerLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103.566,
    height: 116.5,
    viewBox: "0 0 103.566 116.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke-miterlimit:10;stroke-width:4px;}.a{stroke:#021d49;}.b{stroke:#5db014;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-550.029 -269.505)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M597.843,310.9V295.77c0-8.254-14.595-12.51-22.405-12.51s-22.4,4.256-22.4,12.51V310.9",
    transform: "translate(6.46 75.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M566.83,305.957h0a12.482,12.482,0,0,1-12.443-12.444v-2.49a12.482,12.482,0,0,1,12.443-12.444h0a12.478,12.478,0,0,1,12.444,12.444v2.49A12.478,12.478,0,0,1,566.83,305.957Z",
    transform: "translate(15.067 45.199)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M564.473,333.732H559.5a7.468,7.468,0,0,1-7.471-7.464V278.976A7.493,7.493,0,0,1,559.5,271.5h84.625a7.474,7.474,0,0,1,7.471,7.471v47.293a7.468,7.468,0,0,1-7.471,7.464H628.436l-17.595,19.257a2.453,2.453,0,0,1-4.049-1.833V333.732h-7.471",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 52.271,
    transform: "translate(574.432 291.42)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 52.271,
    transform: "translate(574.432 301.376)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 34.847,
    transform: "translate(574.432 311.332)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerLogin);
export default __webpack_public_path__ + "static/media/career-login.f4ace8d8d1649ee758ed8dadcb0db16b.svg";
export { ForwardRef as ReactComponent };